function ClientsIcon({ color = '#959FAF', size = '17', style = {} }) {
  return (
    <svg
      style={{ ...style }}
      width={size}
      height={size}
      viewBox="0 0 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0909 16V14.3333C14.0909 13.4493 13.7461 12.6014 13.1323 11.9763C12.5186 11.3512 11.6862 11 10.8182 11H4.27273C3.40475 11 2.57232 11.3512 1.95856 11.9763C1.3448 12.6014 1 13.4493 1 14.3333V16M19 16V14.3333C18.9995 13.5948 18.7581 12.8773 18.3138 12.2936C17.8696 11.7099 17.2476 11.293 16.5455 11.1083M13.2727 1.10833C13.9767 1.29192 14.6007 1.70892 15.0462 2.29359C15.4918 2.87827 15.7337 3.59736 15.7337 4.3375C15.7337 5.07764 15.4918 5.79673 15.0462 6.38141C14.6007 6.96608 13.9767 7.38308 13.2727 7.56667M10.8182 4.33333C10.8182 6.17428 9.35293 7.66667 7.54545 7.66667C5.73798 7.66667 4.27273 6.17428 4.27273 4.33333C4.27273 2.49238 5.73798 1 7.54545 1C9.35293 1 10.8182 2.49238 10.8182 4.33333Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ClientsIcon;
